<template>
  <section-layout :showButton="false">
    <template v-slot:title>
      {{localization.tabsTitles.estadisticas}}
    </template>
    <template v-slot:content>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-medium-title class="pr-5">
              {{localization.filtros.title}}
            </o-medium-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <filtrosEstadisticas tipo="estadisticasIncidencias"
              :disabled="loading" @aplicar="aplicarFiltros"
              @borrar="borrarFiltros" @exportar="exportarExcel" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-4">
        <v-container fluid>
          <v-data-table :headers="headers" :items="estadisticas"
            :search="tableSearch" :loading="loading"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': [10, 20, 30, 40, 50, -1]
            }">
            <template v-slot:top>
              <v-row no-gutters justify="end" align="center">
                <v-col cols="4">
                  <v-text-field  v-model="tableSearch" id="tableSearch" :label="$t('buscar')" prepend-icon="search" />
                </v-col>
              </v-row>
            </template>
            <template
              v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.incidenciaId">
                  <!--
                  235253 - eliminamos columna incidenciaID tipoSolicitud y responsable
                  <td>{{ item.incidenciaId }}</td>
                  <td>{{ item.tipoSolicitud }}</td>
                  <td>{{ item.nombreResponsable }}</td>
                  -->
                  <td>{{ item.promocion }}</td>
                  <td>{{ traduccionOficio(item) }}</td>
                  <td>{{ item.proveedor }}</td>
                  <td>{{ item.recibida }}</td>
                  <td>{{ item.primaria }}</td>
                  <td>{{ item.reincidencia }}</td>
                  <td>{{ item.reabierta }}</td>
                  <td>{{ item.normal }}</td>
                  <td>{{ item.urgente }}</td>
                  <td>{{ item.muy_urgente }}</td>
                  <td>{{ item.cerrada }}</td>
                  <td>{{ item.fuera_plazo }}</td>
                  <td>{{ item.pendiente }}</td>
                  <td>{{ item.primaria }}</td>
                  <td>{{ item.min_dias }}</td>
                  <td>{{ $options.filters.decimalInput(item.med_dias) }}</td>
                  <td>{{ item.max_dias }}</td>
                </tr>
              </tbody>
            </template>
            <!-- <template v-slot:item.med_dias="{item}">
              {{$options.filters.decimalInput(item.med_dias)}}
            </template> -->
          </v-data-table>
        </v-container>
      </v-card>
    </template>
  </section-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import filtrosEstadisticas from './filtrosEstadisticas'
import mixinExcel from '@/mixins/downloadExcel'

export default {
  mixins: [mixinExcel],
  components: {
    filtrosEstadisticas
  },
  data () {
    return {
      loading: false,
      tableSearch: '',
      estadisticas: []
    }
  },
  computed: {
    ...mapGetters({
    }),
    localization () {
      return this.$t('sectionInformes')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    headers () {
      return [
        //235253 - eliminamos columna incidenciaID tipoSolicitud y responsable
        /*
        { text: this.localization.relacionIncidencias.referencia, value: 'incidenciaId' },
        { text: this.localization.estadisticas.tipoSolicitud, value: 'tipoSolicitud' },
        { text: this.localization.estadisticas.responsable, value: 'responsable' },
        */
        { text: this.localization.estadisticas.promocion, value: 'promocion' },
        { text: this.localization.estadisticas.oficio, value: 'oficio' },
        { text: this.localization.estadisticas.proveedor, value: 'proveedor' },
        { text: this.localization.estadisticas.recibidas, value: 'recibida' },
        { text: this.localization.estadisticas.primarias, value: 'primaria' },
        { text: this.localization.estadisticas.reincidencia, value: 'reincidencia' },
        { text: this.localization.estadisticas.reabiertas, value: 'reabierta' },
        { text: this.localization.estadisticas.normales, value: 'normal' },
        { text: this.localization.estadisticas.urgentes, value: 'urgente' },
        { text: this.localization.estadisticas.muyUrgentes, value: 'muy_urgente' },
        { text: this.localization.estadisticas.cerradas, value: 'cerrada' },
        { text: this.localization.estadisticas.fueraPlazo, value: 'fuera_plazo' },
        { text: this.localization.estadisticas.pendientes, value: 'pendiente' },
        { text: this.localization.estadisticas.rechazadas, value: 'primaria' },
        { text: this.localization.estadisticas.diasMin, value: 'min_dias' },
        { text: this.localization.estadisticas.diasMed, value: 'med_dias' },
        { text: this.localization.estadisticas.diasMax, value: 'max_dias' }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getEstadisticasIncidencias: 'informes/getEstadisticasIncidencias'
    }),
    async aplicarFiltros (values) {
      try {
        this.loading = true
        var respuesta = await this.getEstadisticasIncidencias(values)
        this.estadisticas = respuesta.data
      } catch (error) {
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    borrarFiltros () {
      this.incidencias = []
    },
    async exportarExcel (values) {
      try {
        this.loading = true
        let file = await this.getEstadisticasIncidencias(values)
        console.log(file.file || file.data)
        this.downloadExcel(file.file || file.data)
      } catch (error) {
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    traduccionOficio (item) {
      if(this.usuario.idioma === 'spa') {
        return item.oficio
      } else {
        let tradOficio = JSON.parse(item.traduccionOficio)
        if(tradOficio) {
          return tradOficio[this.usuario.idioma] || item.oficio
        } else {
          return item.oficio
        }
        
      }
    }
  }
}
</script>
